var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"hello"},[_c('h1',[_vm._v("教育圈")]),_vm._v(" "),_c('img',{staticClass:"img_1",attrs:{"src":require("../assets/logo.png"),"width":"100%"},on:{"click":_vm.open_app_click}}),_vm._v(" "),_c('div',[_c('img',{staticClass:"img_1",attrs:{"src":require("../assets/h5_open_app.png")},on:{"click":_vm.open_app_click}})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-435881f2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/EduDownload.vue
// module id = null
// module chunks = 